import styled from '@emotion/styled';
import { MOBILE_BP } from './Calendar.styled';
import { gridLocation } from './event-manipulation';
import { IEventBlock } from './types';

const percentageOffsetFromNights = (nights: number, offsetStart: boolean = false) => {
	// how wide as a percentage is the grid of 7 days relative to block of X nights
	const base = (7 / nights) * 100;
	// how wide is a single cell relative to booking of X nights
	const singleCellWidth = base / 7;
	return singleCellWidth * (offsetStart ? 0.25 : 0.75);
};

const calculateGridArea = (event: IEventBlock) => {
	const { day, week, nights } = gridLocation(event.start, event.end);
	return `${week + 1} / ${day + 1} / auto / span ${nights + 1};`;
};

const calcMarginPerEventStart = (eventContainsStart: boolean, nights: number, isContiguousEvent: boolean) => {
	if (eventContainsStart && isContiguousEvent) {
		return `calc(${percentageOffsetFromNights(nights + 1, true)}% + 5px)`;
	} else if (eventContainsStart) {
		return '2px';
	}
	return 0;
};

const Base = styled.div<IEventBlock>`
	@media only screen and (min-width: ${MOBILE_BP}) {
		height: 40px;
		margin-bottom: 20px;
		padding: 0 10px 0 20px;
		border-radius: ${({ blockContainsStart: eventContainsStart, blockContainsEnd: eventContainsEnd }) => `
			${eventContainsStart ? '20px' : '0'} ${eventContainsEnd ? '20px' : '0'} ${eventContainsEnd ? '20px' : '0'} ${eventContainsStart ? '20px' : '0'};
	`};
	}

	overflow: hidden;
	white-space: nowrap;
	padding: 0 5px 0 10px;
	height: 20px;
	box-sizing: border-box;
	align-self: end;
	margin-bottom: 10px;
	margin-left: ${({ blockContainsStart: eventContainsStart, contiguousEvent, nights }) => {
		return calcMarginPerEventStart(eventContainsStart, nights, contiguousEvent);
	}};
	margin-right: ${({ blockContainsEnd: eventContainsEnd, nights }) => {
		return eventContainsEnd ? `${percentageOffsetFromNights(nights + 1)}%` : 0;
	}};
	position: relative;
	border-radius: ${({ blockContainsStart: eventContainsStart, blockContainsEnd: eventContainsEnd }) => `
		${eventContainsStart ? '10px' : '0'} ${eventContainsEnd ? '10px' : '0'} ${eventContainsEnd ? '10px' : '0'} ${eventContainsStart ? '10px' : '0'};
	`};
	grid-area: ${(event) => calculateGridArea(event)};
	cursor: pointer;
	&:hover {
		background-image: none;
	};
`;

export const StyledEvent = styled(Base)`
	background-image: url('/71eb904/assets/images/BG.svg');
	background-color: #1262f8;
	background-position: 0;
	color: #FFFFFF;
	text-shadow: 0 0 4px #0d54d8;
	&:hover {
		background-color: #004FE4;
	};
`;

export const StyledSynced = styled(Base)`
	background: repeating-linear-gradient(
		-45deg,
		#BFD1F8,
		#BFD1F8 15px,
		#D4DFF9 15px,
		#D4DFF9 25px
	);
	color: #444444;
	text-shadow: 0 0 4px #BFD1F8;
	font-size: 12px;
	&:hover {
		background-color: #BFD1F8;
	};
`;
